import { useState } from "react";
import "./PasswordForget.css";
import axios from "axios";
import { response } from "express";
export default function PasswordForget() {
 const [EmailAccount, setEmailAccount] = useState("");
 const [PopUp, setPopUp] = useState(false);
 const [PopUpError, setPopUpError] = useState(false);

 const [Laoder, setLaoder] = useState(false);
 const [messageSussess, setMessageSussess] = useState("");

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
      if (!EmailAccount) {
        setPopUpError(true);
        setMessageSussess("Votre email n'est pas valide.");
        setTimeout(() => {
        setPopUpError(false);
        setMessageSussess("");

      }, 3000);
      return;
    }
    const formData = new FormData();
    formData.append("EmailAccount", EmailAccount);
    try{
      const response = await axios.post(`${process.env.REACT_APP_PHP_APP_URL}/CheckPassword`, formData);
      setPopUp(true);
      setMessageSussess(response.data.message);
      setTimeout(() => {
        setPopUp(false);
        setMessageSussess("");
      }, 4000);

    }catch(err){
        

      ;
  };
  };
  const Goback=(e: React.MouseEvent<HTMLAnchorElement>)=>{
    e.preventDefault();
    window.history.back();
  }

  return (
    <>
     {Laoder ? (
          <div
            className="d-flex justify-content-center align-items-center"
            style={{ height: "250px", color: "#FFC400" }}
          >
            <div className="spinner-border custom-spinner" role="status"></div>
            <span className="loader-charg">Chargement</span>
          </div>
        ) : (

    <div className="mdpo-recovery-container">
      {PopUp && (
        <div className="popup-success">
          <div className="popup-content">
            <div className="popup-icon">
              <i className="bi bi-check-circle-fill"></i>
            </div>
            <h5>Félicitations !</h5>
            <p>{messageSussess}</p>
          </div>
        </div>
      )}
       {PopUpError && (
        <div className="popup-success">
          <div className="popup-content">
            <div className="popup-icon">
              <i className="bi bi-check-circle-fill"></i>
            </div>
            <h5>Erreur !</h5>
            <p>{messageSussess}</p>
          </div>
        </div>
      )}
      <div className="mdpo-recovery-card">
        <div className="mdpo-icon-wrapper">
          <span className="mdpo-phone-icon"><i className="bi bi-telephone"></i></span>
        </div>

        <h2 className="mdpo-title">Récupération du mot de passe</h2>
        <p className="mdpo-subtitle">
          Entrez votre email pour recevoir le nouveau mote de passe.
        </p>

        <form onSubmit={handleSubmit} className="mdpo-form">
          <label className="mdpo-label">Entrez Votre Email</label>

           <input
                type="email"
                className="form-control mdpo-input"
                placeholder="exemple@gmail.com"
                value={EmailAccount}
                onChange={(e) => {
                  setEmailAccount(e.target.value);
                }}
              />

          <button type="submit" className="mdpo-btn-submit">
            Envoyer <i className="bi bi-arrow-right-circle"></i>
          </button>
        </form>

        <a href="" className="mdpo-back-link" onClick={Goback}>
          <i className="bi bi-arrow-left-circle"></i> Retour à la connexion
        </a>
      </div>
    </div>
        )}
    </>

  );
};